{
	"title": "The transactions listed below were flagged as having incorrect carbon allocation.",
	"description": "We recommend reviewing them one by one, but if you are sure that all transactions below have the correct carbon allocation, you can click the 'Mark all transactions as Resolved' button.",
	"resolveAllFlagged": "Mark all transactions below as Resolved"
}
